import { useDispatch } from 'react-redux'
import { deleteNewTaskTag } from 'store/taskTags'
import Button from 'ui/components/buttons/Button/'
import Icon from 'ui/components/Icon'
import {
  TaskTagNewStyled,
  TextCell,
  ColorCell,
  CheckboxCell,
  FormButtonWrap,
  Cell,
} from './styled'

const TaskTagNew = ({ tag }) => {
  const dispatch = useDispatch()

  return (
    <TaskTagNewStyled>
      <TextCell>{tag.name}</TextCell>
      <TextCell>{tag.description}</TextCell>
      <ColorCell color={tag.bg_color} />
      <CheckboxCell>
        {tag.is_active ? (
          <Icon name="visibility-on" />
        ) : (
          <Icon name="visibility-off" />
        )}
      </CheckboxCell>
      <FormButtonWrap>
        <Button
          type="button"
          theme="colorGray"
          icon={<Icon name="delete" size={16} />}
          onClick={() => {
            dispatch(deleteNewTaskTag(tag.id))
          }}
        />
      </FormButtonWrap>
      <Cell />
    </TaskTagNewStyled>
  )
}

export default TaskTagNew
